export enum ITEM_TYPES {
  TIPTILE = 'TIPTILE',
  CONFIGURABLE = 'CONFIGURABLE',
}
